import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { setConversationActive, setParticipantSelected } from '../../stories/actions';

import Label from '../Labels/Label';

import "./Home.css";

const UserSingle = ({ usersLogged, username, roomSocketId,
    setConversationActiveAction, isSelected, onSelected }) => {
    const selectStyle = isSelected ? { color: "#008b00" } : { color: "#000000" };
    const selectIcon = isSelected ? "check_circle" : "person";

    const handlerOpenActive = () => {
        if (usersLogged) {
            if (usersLogged.roomSocketId !== roomSocketId) {
                if (isSelected) {
                    setConversationActiveAction(null);
                } else {
                    setConversationActiveAction(usersLogged);
                }
            }

            onSelected();
        }
    };

    return (!usersLogged.isAdmin) && (
        <div className="user_single_container" onClick={handlerOpenActive}>
            <span className="material-symbols-outlined user_single_icon" style={selectStyle}>{selectIcon}</span>
            <span className="user_single_name" style={selectStyle}>{username}</span>
        </div>
    );
};

const UsersLoggeds = ({ roomSocketId, usersLoggeds, setConversationActiveAction,
    participantSelected, setParticipantSelectedAction }) => {
    const [inputValue, setInputValue] = useState("");
    const [isSearch, setIsSearch] = useState(false);
    const [usersToDisplay, setUsersToDisplay] = useState(usersLoggeds);

    const handleSelectUser = (value) => {
        setParticipantSelectedAction(value === participantSelected ? null : value);
    };

    const handleSearch = () => {
        const query = inputValue.trim().toLowerCase();

        if (query && !isSearch) {
            setIsSearch(true);
            setUsersToDisplay(usersLoggeds.filter((user) => user.username.toLowerCase().includes(query)));
        } else {
            setIsSearch(false);
            setUsersToDisplay(usersLoggeds);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
            setInputValue("");
        }
    };

    useEffect(() => {
        setUsersToDisplay(usersLoggeds);
    }, [usersLoggeds]);

    return (
        <div className="row users_loggeds_container">
            <Label text="USUÁRIOS" />

            <div className="col-md-12 mb-2">
                <div className="input_group_container">
                    <input
                        type="text"
                        value={inputValue}
                        placeholder="Pesquisar..."
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        className="form-control input_theme_style"
                    />
                    <span
                        className="material-symbols-outlined btn_icon_circle"
                        title={isSearch ? "Limpar pesquisa" : "Pesquisar usuário"}
                        onClick={handleSearch}>
                        {isSearch ? "mop" : "search"}
                    </span>
                </div>
            </div>

            <div className="col-md-12 mb-2 users_loggeds_list">
                {usersToDisplay
                    .filter((user, index, self) => index === self.findIndex(u => u.username === user.username))
                    .map((user, index) => (
                        <UserSingle
                            key={`${user.username}-${index}`}
                            usersLogged={user}
                            username={user.username}
                            roomSocketId={roomSocketId}
                            setConversationActiveAction={setConversationActiveAction}
                            isSelected={participantSelected === user.username}
                            onSelected={() => handleSelectUser(user.username)}
                        />
                    ))}
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setConversationActiveAction: (conversationActive) => dispatch(setConversationActive(conversationActive)),
        setParticipantSelectedAction: (participantSelected) => dispatch(setParticipantSelected(participantSelected)),
    };
};

export default connect(mapStoreToProps, mapActionToProps)(UsersLoggeds);